export const streetTypesList = [
	{
		NAME: 'Alameda',
		VALUE: 'AL',
	},
	{
		NAME: 'Avenida',
		VALUE: 'AV',
	},
	{
		NAME: 'Barrio',
		VALUE: 'BO',
	},
	{
		NAME: 'Calle',
		VALUE: 'CL',
	},
	{
		NAME: 'Camino',
		VALUE: 'CM',
	},
	{
		NAME: 'Carretera',
		VALUE: 'CR',
	},
	{
		NAME: 'Caserío',
		VALUE: 'CS',
	},
	{
		NAME: 'Chalet',
		VALUE: 'CH',
	},
	{
		NAME: 'Colonia',
		VALUE: 'CO',
	},
	{
		NAME: 'Rotonda',
		VALUE: 'GL',
	},
	{
		NAME: 'Parque',
		VALUE: 'PQ',
	},
	{
		NAME: 'Pasaje',
		VALUE: 'PJ',
	},
	{
		NAME: 'Polígono',
		VALUE: 'PG',
	},
	{
		NAME: 'Paseo',
		VALUE: 'PS',
	},
	{
		NAME: 'Plaza',
		VALUE: 'PZ',
	},
	{
		NAME: 'Prolongación',
		VALUE: 'PR',
	},
	{
		NAME: 'Plaza',
		VALUE: 'PZ',
	},
	{
		NAME: 'Rambla',
		VALUE: 'RB',
	},
	{
		NAME: 'Ronda',
		VALUE: 'RD',
	},
	{
		NAME: 'Travesía',
		VALUE: 'TR',
	},
	{
		NAME: 'Urbanización',
		VALUE: 'UR',
	},
];

export const streetTypesTypes = streetTypesList.reduce((acc, item) => {
	acc[item.VALUE] = item.NAME;
	return acc;
}, {});
